export class KioskOfflineLogModel {
    public connectedAt: any;
    public disconnectedAt: any;
}
